import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { destroy } from "../store/thunks.js";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      await dispatch(destroy());
      navigate("/login", { replace: true });
    };

    logout();
  }, [dispatch, navigate]);

  return null;
};

export default Logout;
